module.exports = __webpack_public_path__ + "static/media/logo.ea03f93a.png";